<div #container fxLayout="column">
  <div #controls fxLayout="row" fxLayoutAlign="space-between end">
    <div class="dx-field">
      <div class="dx-field-label">{{ label }}</div>
      <div class="dx-field-value">
        <dx-drop-down-box
          [(value)]="dropDownSelectedItemValue"
          [valueExpr]="keyExpr"
          [displayExpr]="displayExpr"
          [disabled]="disabled"
          [placeholder]="placeholder"
          [dataSource]="items"
          (onOpened)="resizePickerDropDown()">
          <div *dxTemplate="let data of 'content'" id="glassContainer">
            <dx-data-grid
              #dropDownGrid
              [dataSource]="items"
              [columns]="dropDownColumns?dropDownColumns:[]"
              [allowColumnResizing]="true"
              [columnAutoWidth]="true"
              [columnMinWidth]="60"
              [wordWrapEnabled]="true"
              [showRowLines]="true"
              [showBorders]="true"
              [highlightChanges]="true"
              [selection]="{ mode: mode, selectAllMode: 'page' }"
              [hoverStateEnabled]="true"
              [paging]="{ enabled: true, pageSize: 10 }"
              [filterRow]="{ visible: true }"
              height="100%"
              [columnHidingEnabled]="isPhone"
              [(selectedRowKeys)]="dropDownSelectedRow"
              (onSelectionChanged)="dropDownSelectionChanged($event)">
              <dxo-pager
                [visible]="true"
                [allowedPageSizes]="[10, 20, 50, 100]"
                [showInfo]="true"
                [showNavigationButtons]="true"
                [showPageSizeSelector]="true">
              </dxo-pager>
              <dxo-remote-operations [filtering]="true" [sorting]="true" [paging]="true"></dxo-remote-operations>
            </dx-data-grid>
          </div>
        </dx-drop-down-box>
      </div>
    </div>
    <div fxLayout="row" style="max-width: 223px">
      <dx-button
        icon="plus"
        [text]="!isPhone ? 'Add' : ''"
        [disabled]="disabled"
        style="margin-right: 5px; margin-bottom: 5px; height: 26px;"
        (click)="add()"
      ></dx-button>
      <dx-button
        icon="trash"
        [text]="!isPhone ? 'Remove' : ''"
        style="margin-bottom: 5px; height: 26px;"
        [disabled]="disabled || !canRemove()"
        (click)="remove()"
      ></dx-button>
    </div>
  </div>
  <div fxLayout="row" style="max-height: 300px; height: 100%">
    <dx-data-grid
      style="margin-top: 5px; max-height: 295px"
      height="100%"
      #grid
      [wordWrapEnabled]="true"
      [dataSource]="gridItems"
      [columns]="columns ? columns : []"
      [columnAutoWidth]="true"
      [columnMinWidth]="60"
      [showRowLines]="true"
      [showBorders]="true"
      [highlightChanges]="true"
      [allowColumnResizing]="true"
      [(selectedRowKeys)]="gridSelectedRow"
      [columnHidingEnabled]="isPhone"
      (onSelectionChanged)="selectionChange($event)"
      (onRowPrepared)="onRowPrepared($event)"
      (onCellPrepared)="onCellPrepared($event)">
      <dxo-scrolling [showScrollbar]="'always'" [mode]="'virtual'"></dxo-scrolling>
      <dxo-filter-row [showOperationChooser]="true" [visible]="true"></dxo-filter-row>
      <dxo-selection mode="multiple" showCheckBoxesMode="always"></dxo-selection>
      <dxo-sorting mode="multiple"></dxo-sorting>
    </dx-data-grid>
  </div>
</div>
